import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
/** Narrow an arbitrary string to a known Office document type, or null. */ export function asOfficeDocType(t) {
    return t === 'docx' || t === 'xlsx' || t === 'pptx' ? t : null;
}
const OfficeDocumentDrawerCtx = /*#__PURE__*/ createContext({
    isOpen: false,
    documentId: null,
    title: '',
    docType: null,
    previewOnly: false,
    openOffice: ()=>{},
    close: ()=>{},
    proposals: {},
    setProposal: ()=>{}
});
export function OfficeDocumentDrawerProvider({ children }) {
    const [documentId, setDocumentId] = useState(null);
    const [title, setTitle] = useState('');
    const [docType, setDocType] = useState(null);
    const [previewOnly, setPreviewOnly] = useState(false);
    const [proposals, setProposals] = useState({});
    const setProposal = useCallback((id, proposal)=>{
        setProposals((previous)=>{
            const next = {
                ...previous
            };
            if (proposal) next[id] = proposal;
            else delete next[id];
            return next;
        });
    }, []);
    const openOffice = useCallback((id, args)=>{
        setDocumentId(id);
        setTitle(args?.title ?? 'Document');
        setDocType(args?.docType ?? null);
        setPreviewOnly(args?.previewOnly === true);
    }, []);
    const close = useCallback(()=>{
        setDocumentId(null);
        setPreviewOnly(false);
    }, []);
    const value = useMemo(()=>({
            isOpen: !!documentId,
            documentId,
            title,
            docType,
            previewOnly,
            openOffice,
            close,
            proposals,
            setProposal
        }), [
        documentId,
        title,
        docType,
        previewOnly,
        openOffice,
        close,
        proposals,
        setProposal
    ]);
    return /*#__PURE__*/ _jsx(OfficeDocumentDrawerCtx.Provider, {
        value: value,
        children: children
    });
}
export function useOfficeDocumentDrawer() {
    return useContext(OfficeDocumentDrawerCtx);
}
